import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withStyles from 'isomorphic-style-loader/withStyles'
import _ from 'lodash';

import style from './GOATSearchContainer.scss';
import { getPlaceDetails } from '../actions/goat';
import { addClass, removeClass } from '../utils/DOM';

const { Awesomplete } = window;

class GOATSearchContainer extends Component {
  static propTypes = {
    placeholder: PropTypes.string.isRequired,
    ariaLabel: PropTypes.string.isRequired,
    hidden: PropTypes.bool.isRequired,
    onPlaceChange: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.initialState = {
      goatError: false,
      value: '',
    };

    this.state = this.initialState;
  }

  componentDidMount() {
    const { hidden } = this.props;

    this.awesomplete = new Awesomplete(this.$input, { minChars: 1 });
    // sk: needed because we always want to show the results from GOAT
    //     we can guarantee that this is a possible address for the user
    this.awesomplete.filter = () => true;
    this.$input.addEventListener('awesomplete-selectcomplete', this.handleSelectComplete);

    if (hidden) {
      addClass(document.querySelector('.awesomplete'), 'hidden');
    }
  }

  componentDidUpdate() {
    const { hidden } = this.props;

    if (!hidden) {
      removeClass(document.querySelector('.awesomplete'), 'hidden');
    }
  }

  componentWillUnmount() {
    this.destroyAwesomplete();
  }

  searchAddress = _.debounce(({ searchTerm }) => {
    const { dispatch } = this.props;
    dispatch(
      getPlaceDetails({
        address: searchTerm,
      }),
    )
      .then(() => {
        const {predictions} = this.props.goat;
        this.awesomplete.list = predictions.map(prediction => prediction.description);

        this.setState({
          ...this.state,
          predictions,
        });
      })
      .catch(error => {
        console.error('GOATSearchContainer - NYC Geoclient:', error);
        this.setState({
          ...this.state,
          goatError: true,
        });
      });
  }, 250);

  handleResetGoatError = () => {
    this.setState({
      ...this.state,
      goatError: false,
    });
  };

  handleAddressChange = event => {
    const { value } = event.target;
    this.setState({
      ...this.state,
      value,
    });
  };

  handleAddressInput = event => {
    const inputAddress = event.target.value;

    if (!inputAddress.length) {
      return;
    }

    this.searchAddress({ searchTerm: inputAddress });
  };

  handleSelectComplete = event => {
    const formattedAddress = event.text.value;
    const { onPlaceChange } = this.props;
    const { predictions } = this.state;

    predictions.forEach(prediction => {
      if (prediction.description === formattedAddress) {
        onPlaceChange({ prediction });
      }
    });

    this.setState(
      {
        ...this.state,
        value: '',
      },
      () => {
        addClass(document.querySelector('.awesomplete'), 'hidden');
      },
    );
  };

  destroyAwesomplete = () => {
    this.awesomplete = null;
    this.$input.removeEventListener('awesomplete-selectcomplete', this.handleSelectComplete);
  };

  render() {
    const { value } = this.state;
    const {
      //
      placeholder,
      ariaLabel,
      hidden,
    } = this.props;

    return (
      <input
        ref={input => {
          this.$input = input;
        }}
        onChange={this.handleAddressChange}
        onInput={this.handleAddressInput}
        type="text"
        name="new_address"
        id="id_mail_address"
        aria-describedby=""
        placeholder={placeholder}
        autoComplete="off"
        className={style.addressInput}
        aria-label={ariaLabel}
        hidden={hidden}
        value={value}
      />
    );
  }
}
const mapStateToProps = ({ goat }) => ({
  goat,
});

export default compose(
  //
  withStyles(style),
  connect(mapStateToProps),
)(GOATSearchContainer);
